<template>
    <app-dialog :isQrcodeScannerDialog="true" :title="$t('barcode.title')" subtitle="" v-bind="$attrs" @input="onCloseDialog">
        <template v-slot:content>
            <!--<v-progress-circular v-if="!privacyPolicy" indeterminate></v-progress-circular>

            <p v-else class="font-size-md mx-1 description-text" v-html="privacyPolicy"></p>-->
            <v-progress-circular v-if="!showCamera" indeterminate></v-progress-circular>
            <v-row  class="d-flex align-start full-height row-content">
                <v-col cols="10" class="wrap-multi-codes" v-if="showCamera" >
                    <v-checkbox
                        v-model="readMultiCodes"
                        :label="$t('barcode.readMultiple')"
                        ></v-checkbox>

                </v-col>
                <v-col cols="2" class="wrap-total-codes">
                    <v-badge v-if="readMultiCodes"
                        :content="listEan.length"
                        :value="listEan.length"
                        color="green"
                        overlap
                         >

                            <v-btn
                                icon
                                @click="toggleListEan"
                            >
                              <v-icon class="v-icon notranslate dark-blue-color theme--light" large> mdi-barcode-scan</v-icon>
                            </v-btn>
                         <!--<v-btn>

                         </v-btn>-->
                        </v-badge>
                </v-col>
                <v-col cols="12" class="full-height ml-height wrapper-list-ean" v-if="showListEan">
                <v-simple-table ref="tablelistean">
                    <template v-slot:default>
                    <!--<thead>
                        <tr>
                        <th class="text-left">

                        </th>
                        <th class="text-left">

                        </th>

                        </tr>
                    </thead>-->
                    <tbody>
                        <tr
                        v-for="(item,index) in dataEan"
                        :key="item.line"
                        >
                        <td>{{ item.line }}</td>
                        <td>{{ item.code }}</td>
                        <td><v-btn
                            icon
                            color="error"
                            @click="removeEan(item,index)"
                            >
                            <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>
                </v-col>
                <v-col cols="12" class=" ml-height" id="qr_code">
                        <qrcode-scanner
                            :qrbox="{ width: qrWidth, height: qrHeight }"
                                :fps="10"
                                :style="qrStyle"
                                @result="onScan"
                        ></qrcode-scanner>
                    </v-col>
            </v-row>
        </template>

        <template v-slot:buttons="{}">
            <!--<v-btn text class="myprovet-btn-btn-cancel" @click="onCloseDialog" data-cy="app-dialog-confirm-btn">Fechar</v-btn>-->
            <v-btn text v-if="readMultiCodes" class="myprovet-btn-ok" :disabled="listEan.length==0" @click="sendCodes" data-cy="app-dialog-confirm-btn">{{ $t('campaigns.apply') }}</v-btn>
        </template>
    </app-dialog>
</template>

<script>

import QrcodeScanner  from '../QrcodeScanner.vue'
export default {
   components: { QrcodeScanner },
    props: {
        qrWidth:{
            default:'230'
        },
        qrHeight:{
            default:'230'
        },
    },
    data() {
        return {
            showCamera:false,
            readMultiCodes: false,
            searchTerm:null,
            listEan:[],
            showListEan:false,
            qrStyle:{
                default:"width: 340px;margin-left: -5px;"
            }
        };
    },
    computed:{
       dataEan(){
           return _.orderBy(this.listEan,['line'],['desc'])
       }
    },
    created() {
        //window.EventBus.$emit('update:startQRCODE', true)
        setTimeout(()=>{
            this.showCamera=true
        },3000)
       /* if(window.matchMedia("(orientation: landscape)").matches) {
            console.log('landscape');
            setTimeout(()=>{
                this.qrStyle={
                    default:'height:140px; width: 140px;margin-left: -5px;'
                }
            },0)
        }*/
    },
    methods: {
        onCloseDialog() {
            this.readMultiCodes=false
            this.searchTerm=null
            this.listEan=[]
            window.EventBus.$emit('update:stopQRCODE', true)
            this.$emit('onCancel', false);
        },
        onDialogInput(event) {
            console.log(' onDialogInput',event);
            if (!event) {
                this.$emit('onCancel', false);
            }else{
                //console.log(' onDialogInput  window.EventBus', window.EventBus);
                window.EventBus.$emit('update:startQRCODE', true)
            }
        },
        sendCodes(){
            window.EventBus.$emit('update:product-search', this.searchTerm )
            this.onCloseDialog()
        },
        removeEan(item,index){
          this.listEan.splice(index,1)
          this.searchTerm='';
          _.each(this.listEan,(el,i)=>{
                  el.line = i +1
                if(i==0){
                    this.searchTerm = el
                }else{
                    this.searchTerm=this.searchTerm+';'+el
                }
          })
        },
        prepareSearch(code){
          if(this.readMultiCodes){
             let index=_.findIndex(this.listEan,{code:code})
             if(index==-1){
                let line = _.size(this.listEan)
                this.listEan.push({line:line+1,code:code})
                if(this.searchTerm==null){
                    this.searchTerm= code
                }else{
                    this.searchTerm=this.searchTerm+';'+code
                }
             }
             //console.log('list:code',this.listEan,this.searchTerm);
          }else{
            window.EventBus.$emit('update:product-search', code )
            this.onCloseDialog()
          }
        },
        onScan(decodedText, decodedResult) {
        // handle the message here :)
        //console.log('onScan qrcode',decodedText, decodedResult)
        let code = _.trim(_.clone(decodedText))
            if(_.size(code)>=5)
                this.prepareSearch(code)

        },
        toggleListEan(){
            this.showListEan=!this.showListEan

        },
        scrollDwon(){
            if(this.showListEan){
                    const el = this.$refs.tablelistean;
                    //console.log('el',this.$refs,el,this.$el);
                        if (el) {
                        // Use el.scrollIntoView() to instantly scroll to the element
                           // el.scrollIntoView({behavior: 'smooth'});
                           /*window.scrollTo({
                                top: el.scrollHeight,
                                behavior: 'smooth'
                            })*/
                            el.$el.scrollTop = el.$el.lastElementChild.offsetTop;
                            el.$el.scrollIntoView({behavior: 'smooth'});
                        }
            }
        }
    },
};
</script>
